/**
 * Unified cache system for visual rendering components
 *
 * Aggregates ParagraphCache and ImageCache to provide a single cache interface
 * for Visual implementations. This allows Visual classes to manage both text
 * and image caching through a unified interface.
 */

import { ImageCache } from '@image';
import { ParagraphCache } from '@typography';

export class VisualCache {
  #paragraphCache: ParagraphCache;
  #imageCache: ImageCache;

  constructor(paragraphCache?: ParagraphCache, imageCache?: ImageCache) {
    this.#paragraphCache = paragraphCache ?? new ParagraphCache();
    this.#imageCache = imageCache ?? new ImageCache();
  }

  /**
   * Get the paragraph cache for text rendering operations
   */
  get paragraphCache(): ParagraphCache {
    return this.#paragraphCache;
  }

  /**
   * Get the image cache for image rendering operations
   */
  get imageCache(): ImageCache {
    return this.#imageCache;
  }

  /**
   * Clear both paragraph and image caches
   */
  clear(): void {
    this.#paragraphCache.clear();
    this.#imageCache.clear();
  }
}
